module.exports = __webpack_public_path__ + "media/images/application/icons/icon-lock-d69efbb8017692dabf85191f70ac25fd.svg";